import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export function useConversationDescription(conversation) {
  const { t } = useTranslation()

  return useMemo(() => {
    if (conversation?.lastMessage?.text) return conversation.lastMessage.text

    const mime = conversation?.lastMessage?.files?.mimeType ?? conversation?.lastMessage?.files?.mime_type

    if (mime)

      if (/^application/.test(mime)) return t("file")

      else t(mime.split("/")[0])

    if (conversation?.lastMessage?.location) return t("Location")

    return ''
  }, [
    conversation?.lastMessage?.text,
    conversation?.lastMessage?.files?.mimeType,
    conversation?.lastMessage?.files?.mime_type,
    conversation?.lastMessage?.location,
    t
  ])
}
